module.exports = __webpack_public_path__ + "static/version1-1-8fb0f85251aa06e23056c5e895a5bf4b.jpg";